const IS_LOCKED = {
    CANCELLED: 'cancelled',
    CLOSED: 'closeDay',
};

export default IS_LOCKED;
